import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showAddMessage: '=',
        list: '='
    },
    template: `
    <p ng-if="vm.list.loading">{{ 'general.Loading data' | translate }}</p>
    <list-no-content ng-if="!vm.list.loading && !vm.list.items.length" show-add-message="vm.showAddMessage"></list-no-content>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/list/factoryEmpty/index.js